import * as React from "react";
import { Button, Typography } from "@material-ui/core";
import { changeUrl } from "common/history";
import { useEventManagerStyles } from "./eventManagerStyles";

export default function ActionsTab({
	event,
	isAdmin,
	onRewardTrophies,
	onForceSync,
}) {
	const classes = useEventManagerStyles();

	return (
		<div className={classes.actionsList}>
			{isAdmin ? (
				<>
					<Button
						variant="outlined"
						color="primary"
						onClick={onRewardTrophies}
					>
						{event.trophiesAwarded > 0
							? "Recalculate trophies"
							: "Reward trophies"}
					</Button>
					{event.trophiesAwarded > 0 ? (
						<Typography variant="body2" className={classes.actionsNote}>
							{event.trophiesAwarded} trophies awarded
						</Typography>
					) : null}
				</>
			) : null}
			{event.eventFormatId ? (
				<Button
					variant="outlined"
					color="primary"
					onClick={() =>
						changeUrl(
							`/admin/eventFormatBuilder?formatId=${event.eventFormatId}`
						)
					}
				>
					Edit format
				</Button>
			) : null}
			{isAdmin ? (
				<Button variant="outlined" color="primary" onClick={onForceSync}>
					Force sync
				</Button>
			) : null}
		</div>
	);
}
